class EventBus {
  constructor() {
    this.listeners = new Map();
  }

  on(event, callback) {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, new Set());
    }

    this.listeners.get(event).add(callback);

    return () => this.off(event, callback);
  }

  off(event, callback) {
    const callbacks = this.listeners.get(event);
    if (callbacks) {
      callbacks.delete(callback);
      if (callbacks.size === 0) {
        this.listeners.delete(event);
      }
    }
  }

  emit(event, data) {
    const callbacks = this.listeners.get(event);
    if (callbacks) {
      callbacks.forEach((callback) => {
        try {
          callback(data);
        } catch (error) {
          console.error(`Error in event listener for ${event}:`, error);
        }
      });
    }
  }

  once(event, callback) {
    const onceWrapper = (data) => {
      callback(data);
      this.off(event, onceWrapper);
    };
    this.on(event, onceWrapper);
  }

  clear(event) {
    if (event) {
      this.listeners.delete(event);
    } else {
      this.listeners.clear();
    }
  }
}

export const eventBus = new EventBus();

export const EVENTS = {
  DISTRIBUTION_CHANGED: "distribution:changed",
  DISTRIBUTION_COMMITTED: "distribution:committed",
  DISTRIBUTION_RESET: "distribution:reset",

  COLUMN_ADDED: "column:added",
  COLUMN_REMOVED: "column:removed",
  COLUMN_RESIZED: "column:resized",
  COLUMN_REORDERED: "column:reordered",

  CELL_FOCUSED: "cell:focused",
  CELL_BLURRED: "cell:blurred",
  CELL_EDITED: "cell:edited",
  CELL_VALUE_CHANGED: "cell:valueChanged",

  CUSTOMER_HEADER_CHANGED: "customer:headerChanged",
  CUSTOMER_TORIOIKI_CHANGED: "customer:torioikiChanged",
  CUSTOMER_BASHO_CHANGED: "customer:bashoChanged",
  CUSTOMER_EDABAN_CHANGED: "customer:edabanChanged",

  CLIPBOARD_COPY: "clipboard:copy",
  CLIPBOARD_PASTE: "clipboard:paste",
  CLIPBOARD_CLEAR: "clipboard:clear",

  TABLE_SCROLLED: "table:scrolled",
  TABLE_SORTED: "table:sorted",
  TABLE_FILTERED: "table:filtered",

  LOG_ENTRY_ADDED: "log:entryAdded",
  LOG_CLEARED: "log:cleared",
  LOG_PANEL_TOGGLED: "log:panelToggled",

  ORDER_PANEL_TOGGLED: "order:panelToggled",

  LOG_UNDO: 'log:undo',
  LOG_REDO: 'log:redo',

  RESERVE_CLICKED: "action:reserve",
  SAVE_CLICKED: "action:save",
  CONFIRM_CLICKED: "action:confirm",

  TOOLTIP_SHOW: "ui:tooltipShow",
  TOOLTIP_HIDE: "ui:tooltipHide",
  MODAL_OPENED: "ui:modalOpened",
  MODAL_CLOSED: "ui:modalClosed",
  VALIDATION_ERROR: "ui:validationError",

  EDIT_PERMISSION_CHANGED: "editPermission:changed",
  PERMISSION_CHANGED: "permission:changed",
};

export default EventBus;
